import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects bare, language-prefix-less /area/* URLs to their canonical
 * /en-eg/area/* equivalents.
 *
 * Background: before the /en-eg/ + /ar-eg/ URL restructure, area pages
 * lived at /area/:citySlug. Google indexed a batch of those legacy URLs
 * (e.g. /area/ismailia, /area/dahab). They now render "Area not found"
 * because the bare route mis-maps a CITY slug onto AreaDetail, which
 * expects an AREA slug.
 *
 * public/_redirects already 301s these at the Cloudflare edge for fresh
 * HTTP loads (the SEO-critical path). This component is the client-side
 * safety net for in-app navigation, so a SPA route change to a bare
 * /area/* path doesn't briefly flash the "not found" screen before the
 * redirect fires.
 *
 * Defaults to en-eg (matching LegacyUrlHandler's convention).
 */
const LegacyAreaRedirect = () => {
  const { citySlug, areaSlug } = useParams<{ citySlug?: string; areaSlug?: string }>();

  if (!citySlug) {
    return <Navigate to="/en-eg/area" replace />;
  }
  const target = areaSlug
    ? `/en-eg/area/${citySlug}/${areaSlug}`
    : `/en-eg/area/${citySlug}`;
  return <Navigate to={target} replace />;
};

export default LegacyAreaRedirect;
